module.exports = __webpack_public_path__ + "img/ic_pin_start.6ca547be.png";